import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './SideMenu.css';

const SideMenu = ({ menuOpen, setMenuOpen }) => {

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [menuOpen]);

  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains('side-menu')) {
      setMenuOpen(false);
    }
  };

  return (
    <div 
      className={`side-menu ${menuOpen ? 'active' : ''}`}
      onClick={handleOutsideClick}
    >
      <div className="side-menu-content">
        <button 
          className="close-menu" 
          onClick={() => setMenuOpen(false)}
          aria-label="Close menu"
        >
          &times;
        </button>
        <ul className="menu-list">
          <li><Link to="/" onClick={handleLinkClick}>Home</Link></li>
          <li>
            <Link to="/shop" onClick={handleLinkClick}>Shop</Link>
            <ul className="submenu">
              <li><Link to="/shop#presets" onClick={handleLinkClick}>Presets</Link></li>
              <li><Link to="/shop#prints" onClick={handleLinkClick}>Prints</Link></li>
            </ul>
          </li>
          <li><Link to="/portfolio" onClick={handleLinkClick}>Portfolio</Link></li>
          <li><Link to="/journal" onClick={handleLinkClick}>Journal</Link></li>
          <li><Link to="/about" onClick={handleLinkClick}>About</Link></li>
        </ul>
        <div className="menu-footer">
          <div className="social-links">
            <a href="https://instagram.com" aria-label="Instagram" target="_blank" rel="noopener noreferrer">Instagram</a>
            <a href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noopener noreferrer">Facebook</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideMenu;

